import { envConfig } from '@/configs';
import { TFunction } from 'i18next';

export const getParsedPriceFromFood = (item: UserWeekReserveEntity, t: TFunction): string => ((item?.price ?? 0) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' ' + (envConfig.ui.removeCurrency ? '' : t('common:labels.tomans'));
export const getParsedPrice = (price: number): string => ((price ?? 0) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export default getParsedPriceFromFood;
